const transLink = (link: string = ''): string => {
    if (/^(http|https|\/)/.test(link)) {
        return link;
    }
    return `/${link}`;
};

export default transLink;